import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import PlusIcon from '../../icons/plusicon';
import FpgDisableIcon from '../../icons/fpgdisableicon';
import FpgDeleteIcon from '../../icons/fpgdeleteicon';
import FpgpublishIcon from '../../icons/fpgpublishicon';
import FpgeeditIcon from '../../icons/fpgediticon';
import ShowPassIcon from '../../icons/ShowPassIcon';
import ViewIcon from '../../icons/viewIcon';
import moment from "moment";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ActCreators } from '../../redux/bindActionCretor';
import service from '../../services';
import PopUpCustomAll from '../../component/fpg/create/popUpCustomAll';
import ErrorPopUp from '../../component/errorPopUp';
import Loader from '../../component/loader';
import { PAGE_TAKEOVER_CONDITION_TYPES, PT_CONDITION_TYPE } from '../../cosntants';

const getConditionLabel = (id) => {
    const match = PAGE_TAKEOVER_CONDITION_TYPES.find(c => c._id === id);
    return match ? match.name : id;
};

const mapStateToProps = state => ({
    pageTakeoverEditId: state.pageTakeoverEditId,
})
const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

let sub;
class PageTakeoverView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: true,
            name: '',
            status: '',
            triggerActions: [],
            distinctDisplays: {},
            startDatetime: {},
            endDatetime: {},
            displayPages: [],
            takeoverContent: '',
            hideFromLive: false,
            lastUpdatedBy: '',
            lastUpdatedAt: '',

            deleteModal: false,
            disableModal: false,
            publishModal: false,
            hideFromLiveModal: false,
            showFromLiveModal: false,
            errorPopup: false,
            errorMsg: '',
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    componentDidMount() {
        const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
        if (editId) {
            this.apiserve.sendevent("pageTakeOver|getPageTakeOverById", { id: editId });
        }

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "pageTakeOver|getPageTakeOverById":
                    if (!response.error && response.data) {
                        const data = response.data.data || response.data;
                        this.setState({
                            loaderFlag: false,
                            name: data.name || '',
                            status: data.status || '',
                            triggerActions: data.triggerActions || [],
                            distinctDisplays: data.distinctDisplays || {},
                            startDatetime: data.startDatetime || {},
                            endDatetime: data.endDatetime || {},
                            displayPages: data.displayPages || [],
                            takeoverContent: data.takeoverContent || '',
                            hideFromLive: data.hideFromLive || false,
                            lastUpdatedBy: data.updatedBy || '',
                            lastUpdatedAt: data.updatedAt || '',
                        })
                    } else {
                        this.setState({ loaderFlag: false })
                    }
                    break;
                case "pageTakeOver|delete":
                    if (!response.error) {
                        this.props.history.push('/page-takeover-list')
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data,
                            deleteModal: false
                        })
                    }
                    break;
                case "pageTakeOver|updateStatus":
                    if (!response.error) {
                        this.setState({
                            disableModal: false,
                            publishModal: false,
                            hideFromLiveModal: false,
                            showFromLiveModal: false,
                        })
                        const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
                        this.apiserve.sendevent("pageTakeOver|getPageTakeOverById", { id: editId });
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data,
                            disableModal: false,
                            publishModal: false,
                            hideFromLiveModal: false,
                            showFromLiveModal: false,
                        })
                    }
                    break;
                default:
                    break;
            }
        });
    }

    AddPageTakeover = () => {
        this.props.PageTakeoverEditData("")
        this.props.history.push('/create-page-takeover');
    }

    EditPageTakeover = () => {
        const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
        this.props.history.push(`/create-page-takeover/${editId}/edit`);
    }

    // Delete
    deletePageTakeover = () => {
        this.setState({ deleteModal: true })
    }
    deleteYes = () => {
        const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
        this.apiserve.sendevent("pageTakeOver|delete", { id: editId });
    }

    // Publish
    publishPageTakeover = () => {
        this.setState({ publishModal: true })
    }
    publishYes = () => {
        const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
        this.apiserve.sendevent("pageTakeOver|updateStatus", { id: editId, status: 'active' });
    }

    // Disable
    disablePageTakeover = () => {
        this.setState({ disableModal: true })
    }
    disableYes = () => {
        const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
        this.apiserve.sendevent("pageTakeOver|updateStatus", { id: editId, status: 'inactive' });
    }

    // Hide From Live
    hideFromLive = () => {
        this.setState({ hideFromLiveModal: true })
    }
    hideFromLiveYes = () => {
        const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
        this.apiserve.sendevent("pageTakeOver|updateStatus", { id: editId, status: this.state.status, hideFromLive: true });
    }

    // Show On Live
    showOnLive = () => {
        this.setState({ showFromLiveModal: true })
    }
    showOnLiveYes = () => {
        const editId = this.props.pageTakeoverEditId || (this.props.match && this.props.match.params && this.props.match.params.pageTakeoverEditId);
        this.apiserve.sendevent("pageTakeOver|updateStatus", { id: editId, status: this.state.status, hideFromLive: false });
    }

    closeModal = () => {
        this.setState({
            deleteModal: false,
            disableModal: false,
            publishModal: false,
            hideFromLiveModal: false,
            showFromLiveModal: false,
        })
    }

    errorMsgPopup = () => {
        this.setState({ errorPopup: false })
    }

    render() {
        const { name, status, triggerActions, distinctDisplays, startDatetime, endDatetime, displayPages, takeoverContent, lastUpdatedBy, lastUpdatedAt } = this.state;

        return (
            <div className="right_side_wrapper">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_center">
                            <div>PAGE TAKEOVER DETAILS</div>
                            <span onClick={this.AddPageTakeover}><PlusIcon /></span>
                        </p>
                    </li>
                </ul>
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                    <Link className="back_link" to="/page-takeover-list">
                        <svg width="5" height="10" viewBox="0 0 5 10" fill="none"><path d="M5 0L0 5L5 10V0Z" fill="black" /></svg>
                        Back to List
                    </Link>
                    {lastUpdatedAt &&
                        <p className="update_date">
                            Last Update: {moment(lastUpdatedAt).format('h:mm A')} - {moment(lastUpdatedAt).format('MM/DD/YY')}
                            {lastUpdatedBy && ` by ${lastUpdatedBy.fname || ''} ${lastUpdatedBy.lname || ''}`}
                        </p>
                    }
                </div>

                <div className="fpg_tabcontent pl_15 page_takeover_view">
                    {/* Action Buttons */}
                    <div className="fpg_edits_links d_flex d_flex_align_center d_flex_justify_center">
                        <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.EditPageTakeover()}>
                            <FpgeeditIcon />
                            EDIT
                        </Link>
                        {status === 'active' ?
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.disablePageTakeover()}>
                                <FpgDisableIcon /> DISABLE
                            </Link>
                            :
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.publishPageTakeover()}>
                                <FpgpublishIcon /> PUBLISH
                            </Link>
                        }
                        {this.state.hideFromLive ?
                            <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.showOnLive()}>
                                <ViewIcon /> Show On Live
                            </Link>
                            :
                            <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.hideFromLive()}>
                                <ShowPassIcon /> Hide From Live
                            </Link>
                        }
                        <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deletePageTakeover()}>
                            <FpgDeleteIcon />
                            DELETE
                        </Link>
                    </div>

                    <div className="d_flex d_flex_justify_spacebt">
                        <div className="location_col feature_col">
                            {/* Basic Info */}
                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label className="font_600">Name</label>
                                        <span>{name}</span>
                                    </li>
                                </ul>
                            </div>

                             {/* Display Pages */}
                            <div className="view_section">
                                <h4 className="view_section_title">Display Pages</h4>
                                <div className="display_pages_tags">
                                    {displayPages && displayPages.length > 0 ? displayPages.map((page, i) => (
                                        <span key={i} className="page_tag">{page}</span>
                                    )) : <p className="no_data_text">No pages selected</p>}
                                </div>
                            </div>

                            {/* Trigger Conditions */}
                            <div className="view_section">
                                <h4 className="view_section_title">Trigger Conditions</h4>
                                {triggerActions && triggerActions.length > 0 ? triggerActions.map((action, i) => (
                                    <div key={i} className="condition_card">
                                        <div className="d_flex">
                                            <label>Type:</label>
                                            <span>{getConditionLabel(action.condition)}</span>
                                        </div>
                                        {action.condition === PT_CONDITION_TYPE.COMPONENT_CLICKED &&
                                            <div className="d_flex">
                                                <label>Target ID:</label>
                                                <span>{action.targetId}</span>
                                            </div>
                                        }
                                        {action.condition === PT_CONDITION_TYPE.EVENT_FIRED &&
                                            <div className="d_flex">
                                                <label>Event Name:</label>
                                                <span>{action.eventName}</span>
                                            </div>
                                        }
                                    </div>
                                )) : <p className="no_data_text">No conditions set</p>}
                            </div>

                            {/* Distinct Displays */}
                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label className="font_600">Distinct Displays</label>
                                        <span>{distinctDisplays.unlimited ? 'Unlimited' : (distinctDisplays.max || 1)}</span>
                                    </li>
                                </ul>
                            </div>

                            {/* Scheduling */}
                            <div className="data_list">
                                <ul>
                                    <li className="d_flex">
                                        <label className="font_600">Start Date</label>
                                        <span>
                                            {startDatetime.enabled && startDatetime.datetime
                                                ? moment(startDatetime.datetime).format('MMMM D, YYYY h:mm A')
                                                : 'Immediate'}
                                        </span>
                                    </li>
                                    <li className="d_flex">
                                        <label className="font_600">End Date</label>
                                        <span>
                                            {endDatetime.enabled && endDatetime.datetime
                                                ? moment(endDatetime.datetime).format('MMMM D, YYYY h:mm A')
                                                : 'No End Date'}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="location_col feature_col">
                            {/* Takeover Content Preview */}
                            <div className="view_section">
                                <h4 className="view_section_title">Takeover Content</h4>
                                {takeoverContent ?
                                    <iframe
                                        title="Takeover Preview"
                                        srcDoc={takeoverContent}
                                        sandbox="allow-same-origin"
                                        className="takeover_preview_iframe"
                                    />
                                    : <p className="no_data_text">No content set</p>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modals */}
                {this.state.deleteModal ?
                    <PopUpCustomAll
                        HeaderName='Delete?'
                        insideDetails='You are about to delete a page takeover and this action is permanent'
                        insideData='Do you want to proceed?'
                        popupState={this.closeModal}
                        yesPopUp={this.deleteYes}
                    />
                    : ''}

                {this.state.disableModal ?
                    <PopUpCustomAll
                        HeaderName='Disable?'
                        insideDetails='You are about to disable this page takeover, which will temporarily make it unavailable'
                        insideData='Do you want to proceed?'
                        popupState={this.closeModal}
                        yesPopUp={this.disableYes}
                    />
                    : ''}

                {this.state.publishModal ?
                    <PopUpCustomAll
                        HeaderName='Publish Changes'
                        insideDetails='Saving the current changes will activate this page takeover'
                        insideData='Do you want to proceed?'
                        popupState={this.closeModal}
                        yesPopUp={this.publishYes}
                    />
                    : ''}

                {this.state.hideFromLiveModal ?
                    <PopUpCustomAll
                        HeaderName='Hide From Live'
                        insideDetails='Saving the current changes will hide it from the site'
                        insideData='Do you want to proceed?'
                        popupState={this.closeModal}
                        yesPopUp={this.hideFromLiveYes}
                    />
                    : ''}

                {this.state.showFromLiveModal ?
                    <PopUpCustomAll
                        HeaderName='Show On Live?'
                        insideDetails='Saving the current changes will show it on the site'
                        insideData='Do you want to proceed?'
                        popupState={this.closeModal}
                        yesPopUp={this.showOnLiveYes}
                    />
                    : ''}

                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                {this.state.loaderFlag ? <Loader /> : ''}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTakeoverView)
